module.exports = __webpack_public_path__ + "img/icon-home.b1649ea9.svg";